'use client';

import { useEffect } from 'react';
import { createClient } from '@/lib/supabase/client';
import { useAuthStore } from '@/stores/auth';

/**
 * AuthProvider - 認証状態管理
 *
 * パフォーマンス最適化:
 * - 初期getUser()呼び出しを削除（Middlewareで認証済み）
 * - onAuthStateChangeのみで認証状態を監視
 * - 全ページでの不要なAPI呼び出しを削減（-300~500ms改善）
 */
export default function AuthProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { setUser, setIsLoading, reset } = useAuthStore();

  useEffect(() => {
    const supabase = createClient();

    // 認証状態の変更を監視（初期セッションも含む）
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(async (_event, session) => {
      if (session?.user) {
        setUser(session.user);
      } else {
        reset();
      }
      setIsLoading(false);
    });

    // 初期状態をすぐに設定（onAuthStateChangeが初回イベントを発火するまで待つ）
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        setUser(session.user);
      }
      setIsLoading(false);
    });

    // クリーンアップ
    return () => {
      subscription.unsubscribe();
    };
  }, [setUser, setIsLoading, reset]);

  return <>{children}</>;
}
